<template>
  <div class="addpaper">
    <el-form
      :model="bannerForm"
      :rules="bannerRules"
      ref="bannerForm"
      class="demo-bannerForm"
      label-position="left"
    >
      <el-form-item label="轮播图：" prop="img">
        <upload-img
          :fixedNumber="[690, 256]"
          fixedName="690:256"
          accept="image/*"
          tip="只支持 690*256 px 尺寸"
          uploadName="上传封面"
          @uploadInfo="uploadInfo"
          :fixedFlag="true"
          fileDir="banner"
          :resultImg="bannerForm.img"
        />
      </el-form-item>
      <el-form-item label="跳转类型：" prop="jumpType">
        <el-select v-model="bannerForm.jumpType" placeholder="请选择跳转类型">
          <el-option
            v-for="item in jumpList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跳转位置：" prop="position">
        <el-select v-model="bannerForm.position" placeholder="请选择轮播图位置">
          <el-option
            v-for="item in positionList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跳转参数：" v-if="bannerForm.jumpType !== 0">
        <el-input
          v-model="bannerForm.parameter"
          placeholder="请输入跳转参数"
        ></el-input>
      </el-form-item>
      <el-form-item style="margin-top: 52px">
        <el-button
          type="primary"
          @click="submitForm('bannerForm')"
          class="enter-btn save-btn"
          :loading="submitLoading"
          >保存</el-button
        >
        <el-button
          @click="resetForm('bannerForm')"
          class="cancel-btn calloff-btn"
          >取消</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import UploadImg from "../../../components/UploadImg";
import { setBanner } from "@/api/home";
export default {
  components: { UploadImg },
  data() {
    return {
      bannerForm: {
        img: "",
        jumpType: "",
        parameter: "",
        position: "",
      },
      jumpList: [],
      positionList: [],
      bannerRules: {
        img: [{ required: true, message: "请上传轮播图", trigger: "change" }],
        jumpType: [
          { required: true, message: "请选择跳转类型", trigger: "change" },
        ],
        parameter: [
          { required: true, message: "请输入跳转路径", trigger: "blur" },
        ],
        position: [
          { required: true, message: "请选择轮播图位置", trigger: "change" },
        ],
      },
      submitLoading: false,
      type: "add",
    };
  },
  created() {
    this.type = this.$route.query.type;
    if (this.type === "edit") {
      this.bannerForm = JSON.parse(localStorage.getItem("bannerInfo"));
    }
  },
  mounted() {
    this.jumpList = this.getDictDatas(this.DICT_TYPE.JUMP_TYPE);
    this.positionList = this.getDictDatas(this.DICT_TYPE.BANNER_POSITION);
  },
  methods: {
    // 上传轮播图
    uploadInfo(info) {
      this.bannerForm.img = info;
    },
    // 新建轮播图
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          if (this.type === "add") {
            await setBanner(this.bannerForm);
            this.$message.success("添加成功！");
            this.$router.go(-1);
          } else {
            const { id, img, jumpType, parameter, position } = this.bannerForm;
            const params = {
              id,
              img,
              jumpType,
              parameter,
              position,
            };
            await setBanner(params);
            this.$message.success("修改成功！");
            this.$router.go(-1);
            localStorage.removeItem("bannerInfo");
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      // this.$refs[formName].resetFields();
      this.$router.go(-1);
      localStorage.removeItem("bannerInfo");
    },
  },
};
</script>
<style lang="scss" scoped>
.addpaper {
  ::v-deep .demo-bannerForm {
    .el-form-item__label {
      white-space: nowrap;
      min-width: 100px;
    }
    .el-input {
      width: 500px;
    }
  }
}
</style>
